export interface CinemaShow {
  id: string;
  movieId: string;
  cinemaName: string;
  province: string;
  city: string;
  hallType: string;
  showDate: string;
  showtimes: string[];
}

export const cinemaShows: CinemaShow[] = [
  { id: "c1", movieId: "1", cinemaName: "星空国际影城（国贸店）", province: "北京市", city: "北京市", hallType: "IMAX 激光厅", showDate: "2026-10-12", showtimes: ["10:30", "13:45", "16:20", "19:10", "21:50"] },
  { id: "c2", movieId: "1", cinemaName: "寰映影城（西单大悦城店）", province: "北京市", city: "北京市", hallType: "杜比全景声厅", showDate: "2026-10-12", showtimes: ["11:00", "14:20", "17:40", "20:30"] },
  { id: "c3", movieId: "12", cinemaName: "星光影城（静安嘉里店）", province: "上海市", city: "上海市", hallType: "IMAX 影院", showDate: "2026-10-12", showtimes: ["09:50", "12:40", "15:30", "18:20", "21:00"] },
  { id: "c4", movieId: "12", cinemaName: "百丽宫影城（陆家嘴店）", province: "上海市", city: "上海市", hallType: "4DX 动感厅", showDate: "2026-10-12", showtimes: ["10:15", "13:20", "16:45", "19:30"] },
  { id: "c5", movieId: "9", cinemaName: "博纳国际影城（天河城店）", province: "广东省", city: "广州市", hallType: "CINITY 厅", showDate: "2026-10-12", showtimes: ["10:00", "13:10", "16:30", "19:40", "22:10"] },
  { id: "c6", movieId: "9", cinemaName: "万达影城（深圳湾店）", province: "广东省", city: "深圳市", hallType: "IMAX 激光厅", showDate: "2026-10-12", showtimes: ["11:20", "14:40", "18:00", "21:10"] },
  { id: "c7", movieId: "7", cinemaName: "太平洋影城（春熙路店）", province: "四川省", city: "成都市", hallType: "儿童主题厅", showDate: "2026-10-12", showtimes: ["09:30", "11:50", "14:10", "16:40", "19:00"] },
  { id: "c8", movieId: "16", cinemaName: "峨影 1958 影城", province: "四川省", city: "成都市", hallType: "标准舒适厅", showDate: "2026-10-12", showtimes: ["10:40", "13:30", "16:50", "20:10"] },
  { id: "c9", movieId: "3", cinemaName: "卢米埃影城（武林店）", province: "浙江省", city: "杭州市", hallType: "杜比影院", showDate: "2026-10-12", showtimes: ["10:10", "13:00", "15:50", "18:40", "21:30"] },
  { id: "c10", movieId: "3", cinemaName: "CGV 影城（印象城店）", province: "浙江省", city: "宁波市", hallType: "激光巨幕厅", showDate: "2026-10-12", showtimes: ["11:30", "14:50", "18:10", "21:20"] },
  { id: "c11", movieId: "2", cinemaName: "幸福蓝海影城（新街口店）", province: "江苏省", city: "南京市", hallType: "IMAX 影院", showDate: "2026-10-12", showtimes: ["10:20", "13:40", "17:00", "20:20"] },
  { id: "c12", movieId: "6", cinemaName: "苏宁影城（观前街店）", province: "江苏省", city: "苏州市", hallType: "标准舒适厅", showDate: "2026-10-12", showtimes: ["09:40", "12:30", "15:20", "18:30", "21:10"] },
  { id: "c13", movieId: "10", cinemaName: "银兴影城（江汉路店）", province: "湖北省", city: "武汉市", hallType: "情侣主题厅", showDate: "2026-10-12", showtimes: ["10:50", "13:50", "17:10", "20:00"] },
  { id: "c14", movieId: "18", cinemaName: "百老汇影城（楚河汉街店）", province: "湖北省", city: "武汉市", hallType: "儿童主题厅", showDate: "2026-10-12", showtimes: ["09:20", "11:40", "14:00", "16:30"] },
  { id: "c15", movieId: "17", cinemaName: "万达影城（曲江店）", province: "陕西省", city: "西安市", hallType: "杜比全景声厅", showDate: "2026-10-12", showtimes: ["10:30", "13:20", "16:40", "19:50", "22:20"] },
  { id: "c16", movieId: "11", cinemaName: "奥斯卡影城（大雁塔店）", province: "陕西省", city: "西安市", hallType: "标准舒适厅", showDate: "2026-10-12", showtimes: ["11:10", "14:30", "17:50", "21:00"] },
  { id: "c17", movieId: "5", cinemaName: "耀莱成龙影城（国瑞城店）", province: "北京市", city: "北京市", hallType: "深夜恐怖专场", showDate: "2026-10-12", showtimes: ["20:40", "22:50", "01:00"] },
  { id: "c18", movieId: "15", cinemaName: "嘉禾影城（龙之梦店）", province: "上海市", city: "上海市", hallType: "深夜恐怖专场", showDate: "2026-10-12", showtimes: ["21:20", "23:30", "01:40"] },
  { id: "c19", movieId: "4", cinemaName: "大地影院（正佳广场店）", province: "广东省", city: "广州市", hallType: "情侣主题厅", showDate: "2026-10-12", showtimes: ["10:45", "13:25", "16:15", "19:05", "21:40"] },
  { id: "c20", movieId: "14", cinemaName: "金逸影城（万象城店）", province: "浙江省", city: "杭州市", hallType: "标准的舒适厅", showDate: "2026-10-12", showtimes: ["09:55", "12:35", "15:15", "18:05", "20:45"] },
  { id: "c21", movieId: "8", cinemaName: "大光明影城（解放碑店）", province: "重庆市", city: "重庆市", hallType: "家庭欢乐厅", showDate: "2026-10-12", showtimes: ["10:05", "12:45", "15:35", "18:25", "21:05"] },
  { id: "c22", movieId: "13", cinemaName: "UME 影城（两江国际店）", province: "重庆市", city: "重庆市", hallType: "激光巨幕厅", showDate: "2026-10-12", showtimes: ["11:15", "14:35", "17:55", "21:15"] },
  { id: "c23", movieId: "12", cinemaName: "中影国际影城（青年大街店）", province: "辽宁省", city: "沈阳市", hallType: "IMAX 激光厅", showDate: "2026-10-12", showtimes: ["10:25", "13:45", "17:05", "20:25"] },
  { id: "c24", movieId: "1", cinemaName: "横店影视城影城（星光店）", province: "云南省", city: "昆明市", hallType: "杜比全景声厅", showDate: "2026-10-12", showtimes: ["10:35", "13:55", "17:15", "20:35"] },
];

export const provinces: string[] = [
  "全部地区",
  "北京市",
  "上海市",
  "广东省",
  "四川省",
  "浙江省",
  "江苏省",
  "湖北省",
  "陕西省",
  "重庆市",
  "辽宁省",
  "云南省",
];

export const cityMap: Record<string, string[]> = {
  "全部地区": ["全部城市"],
  "北京市": ["全部城市", "北京市"],
  "上海市": ["全部城市", "上海市"],
  "广东省": ["全部城市", "广州市", "深圳市"],
  "四川省": ["全部城市", "成都市"],
  "浙江省": ["全部城市", "杭州市", "宁波市"],
  "江苏省": ["全部城市", "南京市", "苏州市"],
  "湖北省": ["全部城市", "武汉市"],
  "陕西省": ["全部城市", "西安市"],
  "重庆市": ["全部城市", "重庆市"],
  "辽宁省": ["全部城市", "沈阳市"],
  "云南省": ["全部城市", "昆明市"],
};